import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <div className="relative h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/c65e36b1c7c4a611fadcdc0fcaa0965a.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-black/45"></div>
      </div>

      <div className="relative z-10 text-center max-w-4xl mx-auto px-6">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Building Communities. Renovating Care.
        </h1>
        <p className="text-xl md:text-2xl text-white mb-8">
          Full-service construction for owners, investors, managers, and general contractors throughout the Mid-Atlantic and Southeast.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="bg-[#C5A55A] text-[#1A1A1A] px-8 py-4 rounded-md text-lg font-semibold hover:bg-[#B8984D] transition-colors whitespace-nowrap cursor-pointer"
          >
            Start a New Project
          </Link>
          <Link
            to="/work"
            className="border-2 border-white text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-white hover:text-[#1A1A1A] transition-colors whitespace-nowrap cursor-pointer"
          >
            View Our Work
          </Link>
        </div>
      </div>
    </div>
  );
}